import { Box, CircularProgress, Stack, Typography } from '@mui/material';

import { FloatingTelehealthPanelShell } from './FloatingTelehealthPanelShell';

interface TelehealthJoiningCallPanelProps {
  patientName?: string | null;
}

export function TelehealthJoiningCallPanel({ patientName }: TelehealthJoiningCallPanelProps) {
  const message = patientName
    ? `Starting your session with ${patientName}...`
    : 'Starting your session...';

  return (
    <FloatingTelehealthPanelShell>
      {() => (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            bgcolor: 'grey.900',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Stack spacing={2} sx={{ alignItems: 'center' }}>
            <CircularProgress size={36} sx={{ color: 'common.white' }} />
            <Typography
              variant="body1"
              sx={{
                color: 'common.white',
                fontWeight: 600,
                textAlign: 'center',
                px: 2,
              }}
            >
              {message}
            </Typography>
          </Stack>
        </Box>
      )}
    </FloatingTelehealthPanelShell>
  );
}
